import './styles/index.scss';
import './styles/print.scss';
import React, { useState} from 'react';
import ReactDOM from 'react-dom';
import clients from './clients.js';
import Router from './modules/Router.js';
import Footer from './modules/Footer.js';
import Header from './modules/Header.js';

const headerNav = {
    agence: "L'agence",
    portfolio: 'Réalisations',
}

const footerNav = {
    legal: 'Mentions Légales'
}

const App = () => {
    const [page, setPage] = useState('agence')
    return (
    <React.StrictMode>
        <Header pages={headerNav} page={page} setPage={setPage}/>
        <Router clients={clients} page={page}/>
        <Footer pages={footerNav} page={page} setPage={setPage}/>
  </React.StrictMode>)
} 

ReactDOM.render(<App/>, document.querySelector('main'));